export const EvaluationTrainingColdCriterion = {
    path: '/evaluation_training_cold_criterion',
    name: 'evaluation_training_cold_criterion',
    component: () => import('@/views/Evaluation/Measure/EvaluationTrainingColdMeasurePage.vue'),
    props: {
        type: 'EVALUATION_TRAINING_COLD',
    },
    children: [
        {
            path: '/evaluation_training_cold_criterion/add',
            name: 'evaluation_training_cold_criterion.add',
            component: () => import('@/views/Evaluation/Measure/Form/EvaluationMeasureForm.vue'),
            props: {
                addAction: true,
                type: 'EVALUATION_TRAINING_COLD',
            }
        },
        {
            path: '/evaluation_training_cold_criterion/edit/:id',
            name: 'evaluation_training_cold_criterion.edit',
            component: () => import('@/views/Evaluation/Measure/Form/EvaluationMeasureForm.vue'),
            props: {
                updateAction: true,
                type: 'EVALUATION_TRAINING_COLD',
            }
        },
        {
            path: '/evaluation_training_cold_criterion/delete/:id',
            name: 'evaluation_training_cold_criterion.delete',
            component: () => import('@/views/Evaluation/Measure/Form/EvaluationMeasureForm.vue'),
            props: {
                deleteAction: true,
                type: 'EVALUATION_TRAINING_COLD',
            }
        },
        {
            path: '/evaluation_training_cold_criterion/view/:id',
            name: 'evaluation_training_cold_criterion.view',
            component: () => import('@/views/Evaluation/Measure/Form/EvaluationMeasureForm.vue'),
            props: {
                viewAction: true,
                type: 'EVALUATION_TRAINING_COLD',
            }
        },
    ]
}